import { ApiLeagueScorecardCompEntry } from "../types";

export default function getCategoryFromPrevious(
  entries: ApiLeagueScorecardCompEntry[]
): string | undefined {
  for (const entry of entries) {
    const category = entry.category.uuid;
    if (category) {
      return category;
    }
  }
  return undefined;
}
